/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OptionDto_Int32 } from '../models/OptionDto_Int32';
import type { Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse';
import type { Wealthlane_Shared_Hosting_Enums_TenantLockState } from '../models/Wealthlane_Shared_Hosting_Enums_TenantLockState';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TenantStateService {

    /**
     * @param sandboxId 
     * @param lockState 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse OK
     * @throws ApiError
     */
    public static putApiIdentityApiSandboxLockState(
sandboxId: string,
lockState?: Wealthlane_Shared_Hosting_Enums_TenantLockState,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/identity/api/sandbox/{sandboxId}/lock-state',
            path: {
                'sandboxId': sandboxId,
            },
            query: {
                'lockState': lockState,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns OptionDto_Int32 OK
     * @throws ApiError
     */
    public static getApiIdentityApiSandboxStateOptions(): CancelablePromise<Array<OptionDto_Int32>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/api/sandbox/state/options',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
